export const en = {
    checkin_from: 'Check in',
    checkout_before: 'Check out',
    guests_count: {
        one: 'Cost for {count} guest',
        some: 'Cost for {count} guests',
        many: 'Cost for {count} guests',
    },
};
